import { Link } from "react-router-dom";
import { t } from "@/i18n-js/instance";

export interface BreadcrumbProps {
  backLink?: string;
  backLinkText?: string;
  hidden?: boolean;
}

export const Breadcrumb = ({
  hidden = false,
  backLink = "",
  backLinkText = t("back"),
}: BreadcrumbProps) => {
  if (hidden || !backLink) {
    return null;
  }
  return (
    <div className="header__name">
      {Boolean(backLink) && (
        <div className="header__breadcrumb">
          <Link to={backLink}>{backLinkText}</Link>
        </div>
      )}
    </div>
  );
};
